module.exports = __webpack_public_path__ + "img/sabt_dar_mahal.9fed699e.png";